import { Card, CardLink } from '@/types/card';
import { Response } from '@/types/response';
import { api } from '@/utils/axios';

export const UpdateCardLink = async (
  id: number,
  values: Partial<CardLink>,
): Promise<Response<Card>> => {
  const res = await api.put(`/app-web/card-links/${id}`, values);
  return res.data;
};

export const DeleteCardLink = async (id: number): Promise<Response<Card>> => {
  const res = await api.delete(`/app-web/card-links/${id}`);
  return res.data;
};

export const IncrementVisitsCount = async (
  id: number,
): Promise<Response<Card>> => {
  const res = await api.post(
    `/app-web/card-links/increment-visits-count/${id}`,
  );
  return res.data;
};
